import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTeacherFile, clearAddFileError } from '../../redux/slices/teacherFilesSlice';
import { toast } from 'react-toastify';
import { FaTimes, FaUpload, FaSpinner } from 'react-icons/fa';
import './AddTeacherFileModal.css';

function AddTeacherFileModal({ isOpen, onClose, classId, onFileAdded }) {
  const dispatch = useDispatch();
  const { addFileLoading, addFileError } = useSelector((state) => state.teacherFiles);
  
  const [formData, setFormData] = useState({
    title: '',
    file: null
  });
  const [filePreview, setFilePreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        file: file
      }));
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setFilePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      toast.error("يرجى إدخال عنوان الملف");
      return;
    }
    
    if (!formData.file) {
      toast.error("يرجى اختيار ملف");
      return;
    }

    try {
      await dispatch(addTeacherFile({
        title: formData.title.trim(),
        class_id: classId,
        file: formData.file
      })).unwrap();
      
      toast.success("تم إضافة الملف بنجاح");
      resetForm();
      onFileAdded();
      onClose();
    } catch (error) {
      toast.error(error || "حدث خطأ في إضافة الملف");
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      file: null
    });
    setFilePreview(null);
    dispatch(clearAddFileError());
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay FileTeacherModal  " onClick={handleClose}>
      <div className="modal-content   " onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>إضافة ملف جديد</h3>
          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="title">عنوان الملف</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="أدخل عنوان الملف"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="file">الملف</label>
            <div className="file-upload-container">
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.jpg,.jpeg,.png"
                required
                className="file-input"
              />
              <label htmlFor="file" className="file-upload-label">
                <FaUpload className="upload-icon" />
                <span>اختر ملف</span>
              </label>
            </div>
            {filePreview && (
              <div className="file-preview">
                <span>تم اختيار: {formData.file?.name}</span>
              </div>
            )}
          </div>

          {addFileError && (
            <div className="error-message">
              {addFileError}
            </div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={addFileLoading}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={addFileLoading}
            >
              {addFileLoading ? (
                <>
                  <FaSpinner className="spinner" />
                  جاري الإضافة...
                </>
              ) : (
                'إضافة الملف'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTeacherFileModal;
